import React, {useEffect, useState} from "react";
import styles from "./Profile.module.css";
import ProfilePersonalDetails from "./profilePersonalDetails/ProfilePersonalDetails";
import CartOverlay from "../../components/cartOverlay/CartOverlay";
import {useCartOverlay} from "../../hooks/useCart";
import {useSectionsRefs} from "../../components/mainWrapper/MainWrapper";
import {useSearchParams} from "react-router-dom";
import ProfileUpdatedMailModal from "./profileUpdatedMailModal/ProfileUpdatedMailModal";
import ProfileUpdatedPasswordlModal from "./profileUpdatePasswordModal/ProfileUpdatedPasswordModal";

const Profile = () => {

    const {isCartOpen, closeCart} = useCartOverlay();

    const {
        setNavItems,
    } = useSectionsRefs();

    const [searchParams] = useSearchParams();

    const [openProfileUpdatedMailModal, setOpenProfileUpdatedMailModal] = useState(false);
    const [openProfileUpdatedPasswordModal, setOpenProfileUpdatedPasswordModal] = useState(false);
    const [mailUpdated, setMailUpdated] = useState(searchParams.get("mailUpdated"));
    const [passwordUpdated, setPasswordUpdated] = useState(searchParams.get("passwordUpdated"));

    useEffect(() => {
        setNavItems([]);
    }, []);

    useEffect(() => {
        if (mailUpdated) {
            setOpenProfileUpdatedMailModal(true);
        }
        if (passwordUpdated) {
            setOpenProfileUpdatedPasswordModal(true);
        }
    }, [searchParams, mailUpdated, setOpenProfileUpdatedMailModal]);

    return (
        <div className={styles.container}>
            <ProfilePersonalDetails/>
            <CartOverlay isCartOpen={isCartOpen} closeCart={closeCart}/>
            <ProfileUpdatedMailModal open={openProfileUpdatedMailModal} setOpen={setOpenProfileUpdatedMailModal}/>
            <ProfileUpdatedPasswordlModal open={openProfileUpdatedPasswordModal} setOpen={setOpenProfileUpdatedPasswordModal}/>
        </div>
    );
}

export default Profile